import React, { useState } from 'react'
import { useAuth } from '../Context/Auth'
import useForm from '../Utils/useForm'
import { validateReset } from '../Utils/validate'
import { Link } from 'react-router-dom'

// styles
import { FlexboxGrid, Button, ButtonToolbar, Form, FormGroup, FormControl, ControlLabel, Panel } from 'rsuite'
// import { Sent } from '../Components/Icons'
import sent from '../Components/Styles/images/sent pic.svg'
import '../Components/Styles/forms.css'
import { colors, fonts } from '../Components/Styles/common-styles'

const style = {
  pStyle: {
    fontSize: fonts.largeSize,
    marginBottom: '10%'
  },
  h3Style: {
    fontSize: fonts.extraLargeSize,
    marginBottom: '10%'

  }
}
export default function ResetPassword () {
  const { resetPassword } = useAuth()
  const { handleChange, handleSubmit, values, errors } = useForm(handleFormSubmit, validateReset)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  // function to handle form submit after fields are validated
  async function handleFormSubmit (e) {
    try {
      setMessage('')
      setError('')
      await resetPassword(values.email)
      setMessage('Check your inbox for further instructions')
      setLoading(true)
    } catch (error) {
      const errorCode = error.code
      const errorMessage = error.message
      setError('Failed to reset password')
      console.log(errorCode + ' ' + errorMessage)
    }
  }
  return (
    <FlexboxGrid justify='center' className='bg'>
      <FlexboxGrid.Item colspan={12}>
        <div id='title' className='nav-text'>
          <span style={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '-5px' }}>TAITO</span>
          <span style={{ fontWeight: '150', fontSize: '20px', marginBottom: '5px' }}>TRAINING</span>
        </div>
        <div>
          <div id='title' style={{ display: 'flex', position: 'absolute', top: '133px', left: '135px', background: `${colors.white}` }}>
            <Link className='back' to='/Login'>&#8592; Back</Link>
          </div>
          <h3 className='header'>Reset password</h3>
        </div>

        {!loading
          ? (
            <>
              <p style={{ position: 'absolute', width: '370px', left: '135px', top: '277px' }}>
                Enter the email associated with your account and we’ll send an email with instructions to reset your password.  </p>
              <Form onSubmit={handleSubmit} className='form' style={{ top: '376px' }} noValidate>
                {message && <div className='error'>{error}</div>}
                <FormGroup>
                  <ControlLabel>Email</ControlLabel>
                  <FormControl
                    className='input'
                    type='email'
                    name='email'
                    onChange={(e) => handleChange('email', e)}
                    values={values.email} placeholder='Your email address'
                    style={{ width: '370px' }} />
                  {errors.email && <div className='error'>{errors.email}</div>}
                  {error && <div className='error'>{error}</div>}
                </FormGroup>
                <FormGroup>
                  <ButtonToolbar>
                    <Button className='button' disabled={loading} type='submit' block>Reset password</Button>
                  </ButtonToolbar>
                </FormGroup>
              </Form>
            </>)
          : (<div className='grid' style={{ position: 'absolute', top: '270px', left: '135px' }}>
            <div style={{ margin: '5% auto' }}>
              <img src={sent} alt='sent' />
            </div>
            <h3 style={style.h3Style}>Check your mail</h3>
            <div>
              <p style={style.pStyle}>We have sent a password recover instructions to your email. </p>
              <p style={style.pStyle}>Didn’t received the email? Check your spam folder or<button onClick={() => { setLoading(false) }} style={{ color: '#5522B5', background: 'none', padding: 'none', border: 'none' }}>request a new email.</button></p>
            </div>

          </div>)}
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={12}>
        <Panel className='bgImage' style={{ backgroundImage: 'url("Images/LoginBg.svg")' }} />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  )
}
